import { render, staticRenderFns } from "./GamePicker.vue?vue&type=template&id=7a56960b&scoped=true"
import script from "./GamePicker.vue?vue&type=script&lang=js"
export * from "./GamePicker.vue?vue&type=script&lang=js"
import style0 from "./GamePicker.vue?vue&type=style&index=0&id=7a56960b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56960b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a56960b')) {
      api.createRecord('7a56960b', component.options)
    } else {
      api.reload('7a56960b', component.options)
    }
    module.hot.accept("./GamePicker.vue?vue&type=template&id=7a56960b&scoped=true", function () {
      api.rerender('7a56960b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/GamePicker.vue"
export default component.exports